/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/11/2022
 */

import React from "react";
import { Divider, IconButton, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { State } from "../../state/store";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "urql";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HeroMessage from "../../components/HeroMessage";
import LoadingHero from "../../components/LoadingHero";
import {
	SummaryNotificationQuery,
	SummaryNotificationQueryVars,
	SummaryNotificationResponse
} from "../../graphql/queries/summary-notifications";
import SummaryForm from "./SummaryForm";
import { defaultSummaryConfig } from "./NewSummary";

export default function EditSummary() {

	const user = useSelector((s:State) => s.user);
	const { id } = useParams<{id?: string}>();

	const [summaryNotificationResult] = useQuery<SummaryNotificationResponse, SummaryNotificationQueryVars>({
		query: SummaryNotificationQuery,
		variables: {
			id: Number(id)
		},
		pause: isNaN(Number(id)) || !user?.id
	});

	const summary = summaryNotificationResult.data?.summaryNotification;
	const editDisabled = summary?.createdBy !== user?.id;

	return (
		<Stack spacing={1} sx={{ p: 1 }}>
			<Stack direction={"row"} alignItems={"center"}>
				<IconButton size={"large"} to={"/notifications/summaries"} component={Link}>
					<ArrowBackIcon />
				</IconButton>
				<Stack>
					<Typography gutterBottom  variant="h4" sx={{ mb: 0, ml: 1 }}>
						Edit Summary Notification #{id}
					</Typography>
				</Stack>
			</Stack>
			<Divider />
			{summaryNotificationResult.error &&
				<HeroMessage
					p={4}
					title={"Request Error"}
					titleTypographyProps={{ variant: "h6" }}
					message={summaryNotificationResult.error.message}
				/>
			}
			{summaryNotificationResult.fetching && <LoadingHero />}
			{!summaryNotificationResult.error && !summaryNotificationResult.fetching && summary && summary.config &&
				<SummaryForm
					id={Number(id)}
					config={{
						...defaultSummaryConfig,
						...summary.config
					}}
					disabled={editDisabled}
				/>}
		</Stack>
	);

}